import { AdminCommercialPerformanceSummary } from "./AdminCommercialPerformanceSummary"
import { AdminCommercialOriginMetrics } from "./AdminCommercialOriginMetrics"

export class AdminCommercialPerformance {
  summary: AdminCommercialPerformanceSummary

  origins: AdminCommercialOriginMetrics[]

  constructor(data: Partial<AdminCommercialPerformance> = {}) {
    this.summary = new AdminCommercialPerformanceSummary(data.summary)

    this.origins = data.origins?.map((item) => new AdminCommercialOriginMetrics(item)) ?? []
  }
}
